/* global DPI_STATS_TMOUT_MS */
import React, { useState, useEffect, useContext } from "react";
import Request from "common/Request";
import Result from "./Result";
import { parseRootUsage } from "./api";
import ActionsContext from "common/ActionsContext";
import { splitClusterResponse } from "common/api";
import styled from "styled-components";
import View from "common/View";

const ContextMenu = () => {
  const actions = useContext(ActionsContext);
  return (
    <ul className="context-menu header-dropdown m-r--5">
      <li>
        <a
          onClick={() => {
            actions.send("do-load");
          }}
          data-toggle="cardloading"
          data-loading-effect="pulse"
          title="Refresh"
        >
          <i className="material-icons">refresh</i>
        </a>
      </li>
    </ul>
  );
};

function parseResponse(input) {
  const parts = splitClusterResponse(input);
  return {
    usage: parts.map((part) => {
      const usage = parseRootUsage(part.resp);
      return { bqnId: part.bqnId, ...usage };
    }),
  };
}

const diskUsageRetrieval = () =>
  ifCl.run("show system filesystem").then(parseResponse);

const Report = () => {
  const actions = useContext(ActionsContext);
  const [request, setRequest] = useState(null);
  const doLoad = () => {
    setRequest(diskUsageRetrieval());
  };
  useEffect(() => doLoad() || actions.recv("do-load", doLoad), []);

  return (
    <Request during={request}>
      {(response) => <Result data={response} />}
    </Request>
  );
};

const DiskStatus = () => (
  <View title="Disk Usage">
    <Report />
  </View>
);
export default DiskStatus;
